import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { loginWithToken } from 'js/actions/account-actions';
import { connect } from 'react-redux';

import TokenAuthenticationComponent from '../components/TokenAuthenticationComponent';

function TokenAuthenticationContainer({
  loginWithToken,
  currentWorkspaceId,
  history,
}) {
  const [signingIn, setSigningIn] = useState(true);
  const { token } = useParams();
  const fromUrl = null;

  useEffect(() => {
    loginWithToken(token)
      .then((me) => {
        let url;

        if (fromUrl != null) {
          url = fromUrl;
        } else if (me.workspaces.length > 0) {
          url = `/w/${currentWorkspaceId || me.workspaces[0].id}/dashboard`;
        } else if (me.accounts.length > 0) {
          url = `/a/${me.accounts[0].id}`;
        } else {
          url = `/dashboard`;
        }

        setTimeout(() => {
          history.push(url);
        }, 0);
      })
      .finally(() => {
        setSigningIn(false);
      });
  }, [token, history, currentWorkspaceId, fromUrl, loginWithToken]);

  return <TokenAuthenticationComponent signingIn={signingIn} />;
}

export default connect(
  (state) => ({
    currentWorkspaceId: state.currentWorkspaceId,
  }),
  { loginWithToken }
)(TokenAuthenticationContainer);
